import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getSuppliesInventoryConfigsCount = unaryRpc({
  name: "getSuppliesInventoryConfigsCount" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ total: z.number() }),
});
